export function QuestionBanksIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.04 3.324c.5-.6 1.421-.6 1.92 0L15.19 6h1.953l-3.03-3.636a2.75 2.75 0 00-4.225 0L6.858 6H8.81l2.23-2.676z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M2 10a4 4 0 014-4h12a4 4 0 014 4v8a4 4 0 01-4 4H6a4 4 0 01-4-4v-8z"
        opacity="0.4"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.25 10A.75.75 0 017 9.25h10a.75.75 0 010 1.5H7a.75.75 0 01-.75-.75zM6.25 14a.75.75 0 01.75-.75h10a.75.75 0 010 1.5H7a.75.75 0 01-.75-.75zM6.25 18a.75.75 0 01.75-.75h5a.75.75 0 010 1.5H7a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}
